import { createFileRoute, Outlet } from '@tanstack/react-router'
import Group from '../../../../../../../containers/group-details'
import { groupDetailSearchSchema } from '../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/$groupId/$viewType'
)({
  validateSearch: groupDetailSearchSchema,
  component: GroupDetailLayout
})

function GroupDetailLayout() {
  return (
    <>
      <Group />
      <Outlet />
    </>
  )
}
